module.exports = __webpack_public_path__ + "img/hero-banner-2.6bcae2d6.jpg";